module.exports = __webpack_public_path__ + "static/media/bl6.c6834abc.jpg";